"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedFreightInternational = void 0;
exports.CombinedFreightInternational = {
    id: 'CombinedFreightInternational',
    companyName: 'Combined Freight International',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'CombinedFreightInternational',
    },
    isInternal: false,
    isActive: true,
    countries: ['PK'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29tYmluZWRGcmVpZ2h0SW50ZXJuYXRpb25hbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9Db21iaW5lZEZyZWlnaHRJbnRlcm5hdGlvbmFsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNEJBQTRCLEdBQVU7SUFDL0MsRUFBRSxFQUFFLDhCQUE4QjtJQUNsQyxXQUFXLEVBQUUsZ0NBQWdDO0lBQzdDLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLDhCQUE4QjtLQUN4QztJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==